export default "__VITE_ASSET__CUnDG4Tw__"